/**
 * OrbDocCommunityContributingSLOrbDocCommunityContributingSLPage
 *
 * Page component for OrbDocCommunityContributingSLOrbDocCommunityContributingSLPage
 * Path: /sl/docs/community/contributing
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCommunityContributingSLDocScreenView as __OrbDocCommunityContributingSLDocScreenView } from '@/components/traits/OrbDocCommunityContributingSLDocScreenView';
import { OrbDocCommunityContributingSLDocAnalyticsView as __OrbDocCommunityContributingSLDocAnalyticsView } from '@/components/traits/OrbDocCommunityContributingSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCommunityContributingSLOrbDocCommunityContributingSLPageProps {
  // Add any page-level props here
}

export function OrbDocCommunityContributingSLOrbDocCommunityContributingSLPage(_props: OrbDocCommunityContributingSLOrbDocCommunityContributingSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Prispevanje","description":"Prijavi težave, izboljšaj dokumentacijo, predlagaj vedenja in prevode.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/community/contributing"},{"locale":"ar","path":"/ar/docs/community/contributing"},{"locale":"sl","path":"/sl/docs/community/contributing"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCommunityContributingSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCommunityContributingSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCommunityContributingSLOrbDocCommunityContributingSLPage;
